module.exports = __webpack_public_path__ + "img/download.8b63277f.svg";